// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"_37d-p","button":"B8vEt","active":"M9S9D"};